<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t(`shared.risk_objects.generic.${risk}`)}}
    span(v-if="id != 1")  ({{id}})
    Icon(:icon="risk" classes="p-title__icon")
  VehicleLegal(:risk="riskId")
  Ownership(:risk="riskId" risk_object="assistance" t_key="vehicle")
  Ownership(:risk="riskId" risk_object="pj" t_key="vehicle")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'
import VehicleLegal from './VehicleLegal'

export default {
  components: {
    Icon,
    Ownership,
    VehicleLegal
  },
  props: {
    id: {
      default: 1
    },
    risk: {
      default: 'car'
    }
  },
  computed: {
    riskId () {
      return `${this.risk}_${this.id}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Vehicle.vue